import { StepProps } from '@betterment/js-runtime';
import { Text } from '@betterment/samba-react';
import { Box, Button, Flex, Heading } from '@betterment/style-closet-react';

import WorkflowSuccessLayout from '../Shared/components/WorkflowSuccessLayout';
import { locationAssign } from '../Shared/path-helpers';

const PinChangeFlowSuccess: React.FC<React.PropsWithChildren<StepProps>> = ({ flowState }) => {
  const { returnToPath: returnTo } = flowState;

  const onClose = () => {
    locationAssign(returnTo);
  };

  return (
    <WorkflowSuccessLayout title="Change PIN" closeHandler={onClose}>
      <Heading as="h1" fontSize={[5, 6]} mb="8">
        Your debit card PIN has been changed.
      </Heading>
      <Flex mb="6" alignItems="baseline">
        <Box mb="8">
          <Flex.Item>
            <Text
              css={{
                lineHeight: 'lineHeight.100',
              }}
            >
              You should receive a confirmation email for your PIN update shortly. This PIN can be used for ATM
              withdrawals or in-store purchases.
            </Text>
          </Flex.Item>
        </Box>
      </Flex>
      <a href={returnTo}>
        <Button type="button" px="8">
          Finish
        </Button>
      </a>
    </WorkflowSuccessLayout>
  );
};

export default PinChangeFlowSuccess;
